export default __webpack_public_path__ + "static/media/84.3b5b6bf9.png";